
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

export default function Privacy() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Política de Privacidade - Take Lead",
    "description": "Política de Privacidade da Take Lead - Como coletamos, usamos e protegemos seus dados pessoais",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/privacy`
  };

  return (
    <div className="min-h-screen bg-black text-white font-['Inter']">
      <SEOHead
        title="Política de Privacidade - Take Lead"
        description="Política de Privacidade da Take Lead - Como coletamos, usamos e protegemos seus dados pessoais conforme a LGPD"
        keywords="política de privacidade, LGPD, proteção de dados, privacidade, Take Lead"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/privacy`}
        structuredData={structuredData}
      />
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Política de Privacidade
            </h1>
            <p className="text-xl text-gray-300">
              Última atualização: Janeiro de 2025
            </p>
          </div>

          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 space-y-8">
            
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Introdução</h2>
              <p className="text-gray-300 leading-relaxed">
                A Take Lead ("nós", "nosso" ou "empresa") está comprometida em proteger e respeitar sua privacidade. 
                Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos suas informações 
                pessoais quando você utiliza nossos serviços de consultoria em prospecção com Inteligência Artificial.
              </p>
              <p className="text-gray-300 leading-relaxed mt-4">
                Esta política está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018) 
                e outras legislações aplicáveis de proteção de dados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Informações que Coletamos</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-blue-400 mb-2">2.1 Dados Fornecidos Diretamente</h3>
                  <ul className="text-gray-300 space-y-2 ml-4">
                    <li>• Nome completo e informações de contato (email, telefone)</li>
                    <li>• Informações profissionais (empresa, cargo)</li>
                    <li>• Dados fornecidos em formulários de contato</li>
                    <li>• Comunicações que você nos envia</li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-blue-400 mb-2">2.2 Dados Coletados Automaticamente</h3>
                  <ul className="text-gray-300 space-y-2 ml-4">
                    <li>• Informações de navegação (páginas visitadas, tempo de permanência)</li>
                    <li>• Dados técnicos (endereço IP, tipo de navegador, dispositivo)</li>
                    <li>• Cookies e tecnologias similares</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Como Utilizamos suas Informações</h2>
              <div className="text-gray-300 space-y-3">
                <p><strong className="text-blue-400">Prestação de Serviços:</strong> Para fornecer nossos serviços de consultoria e prospecção com IA</p>
                <p><strong className="text-blue-400">Comunicação:</strong> Para responder suas solicitações e manter contato sobre nossos serviços</p>
                <p><strong className="text-blue-400">Melhoria dos Serviços:</strong> Para analisar e melhorar nossos serviços e experiência do usuário</p>
                <p><strong className="text-blue-400">Marketing:</strong> Para enviar informações sobre nossos serviços (apenas com seu consentimento)</p>
                <p><strong className="text-blue-400">Cumprimento Legal:</strong> Para cumprir obrigações legais e regulamentares</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Base Legal para Processamento</h2>
              <div className="text-gray-300 space-y-3">
                <p>Processamos seus dados pessoais com base nas seguintes bases legais da LGPD:</p>
                <ul className="space-y-2 ml-4">
                  <li>• <strong className="text-blue-400">Consentimento:</strong> Quando você nos fornece consentimento explícito</li>
                  <li>• <strong className="text-blue-400">Execução de Contrato:</strong> Para cumprir obrigações contratuais</li>
                  <li>• <strong className="text-blue-400">Interesse Legítimo:</strong> Para melhorar nossos serviços e comunicação</li>
                  <li>• <strong className="text-blue-400">Cumprimento de Obrigação Legal:</strong> Para atender requisitos legais</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Compartilhamento de Informações</h2>
              <div className="text-gray-300 space-y-4">
                <p>Não vendemos, alugamos ou comercializamos suas informações pessoais. Podemos compartilhar seus dados apenas nas seguintes situações:</p>
                <ul className="space-y-2 ml-4">
                  <li>• <strong className="text-blue-400">Prestadores de Serviços:</strong> Com fornecedores que nos auxiliam na prestação de serviços</li>
                  <li>• <strong className="text-blue-400">Obrigações Legais:</strong> Quando exigido por lei ou autoridades competentes</li>
                  <li>• <strong className="text-blue-400">Proteção de Direitos:</strong> Para proteger nossos direitos, propriedade ou segurança</li>
                  <li>• <strong className="text-blue-400">Consentimento:</strong> Com seu consentimento explícito para finalidades específicas</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Segurança dos Dados</h2>
              <div className="text-gray-300 space-y-4">
                <p>Implementamos medidas técnicas e organizacionais adequadas para proteger seus dados pessoais:</p>
                <ul className="space-y-2 ml-4">
                  <li>• Criptografia de dados em trânsito e em repouso</li>
                  <li>• Controles de acesso rigorosos</li>
                  <li>• Monitoramento contínuo de segurança</li>
                  <li>• Treinamento regular de nossa equipe</li>
                  <li>• Auditorias periódicas de segurança</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Retenção de Dados</h2>
              <p className="text-gray-300 leading-relaxed">
                Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta política, 
                ou conforme exigido por lei. Os critérios para determinar os períodos de retenção incluem:
              </p>
              <ul className="text-gray-300 space-y-2 ml-4 mt-4">
                <li>• Duração do relacionamento comercial</li>
                <li>• Obrigações legais de retenção</li>
                <li>• Necessidades de defesa em processos legais</li>
                <li>• Consentimento específico para retenção prolongada</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Seus Direitos</h2>
              <div className="text-gray-300 space-y-4">
                <p>Conforme a LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Acesso</h4>
                    <p className="text-sm">Confirmar a existência de tratamento e acessar seus dados</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Correção</h4>
                    <p className="text-sm">Corrigir dados incompletos, inexatos ou desatualizados</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Eliminação</h4>
                    <p className="text-sm">Solicitar a exclusão de dados desnecessários ou excessivos</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Portabilidade</h4>
                    <p className="text-sm">Solicitar a portabilidade dos dados a outro fornecedor</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Oposição</h4>
                    <p className="text-sm">Opor-se ao tratamento realizado com base no interesse legítimo</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg">
                    <h4 className="text-blue-400 font-semibold mb-2">Revogação</h4>
                    <p className="text-sm">Revogar o consentimento a qualquer momento</p>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Cookies e Tecnologias Similares</h2>
              <div className="text-gray-300 space-y-4">
                <p>Utilizamos cookies e tecnologias semelhantes para:</p>
                <ul className="space-y-2 ml-4">
                  <li>• Melhorar a funcionalidade do site</li>
                  <li>• Analisar o uso do site</li>
                  <li>• Personalizar sua experiência</li>
                  <li>• Fornecer conteúdo relevante</li>
                </ul>
                <p className="mt-4">
                  Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Transferência Internacional</h2>
              <p className="text-gray-300 leading-relaxed">
                Caso seja necessário transferir seus dados para outros países, garantiremos que tais transferências 
                sejam realizadas em conformidade com a LGPD e outras leis aplicáveis, implementando salvaguardas 
                adequadas para proteger seus dados pessoais.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Menores de Idade</h2>
              <p className="text-gray-300 leading-relaxed">
                Nossos serviços são direcionados a empresas e profissionais. Não coletamos intencionalmente 
                informações pessoais de menores de 18 anos. Caso tomemos conhecimento de que coletamos dados 
                de menores sem o consentimento adequado, tomaremos medidas para excluir essas informações.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">12. Alterações nesta Política</h2>
              <p className="text-gray-300 leading-relaxed">
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre mudanças 
                significativas através do nosso site ou por email. Recomendamos que você revise esta política 
                regularmente para se manter informado sobre como protegemos suas informações.
              </p>
            </section>

            {/* Seção 13: Contato */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">13. Contato</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Para exercer seus direitos ou esclarecer dúvidas sobre esta Política de Privacidade, entre em contato conosco:
              </p>
              <div className="space-y-2 text-gray-300">
                <p><strong className="text-blue-400">Email:</strong> contato@takelead.com.br</p>
              </div>
            </section>

            {/* Seção 14: Alterações na Política */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">14. Alterações na Política</h2>
              <p className="text-gray-300 leading-relaxed">
                Esta Política de Privacidade pode ser atualizada periodicamente. Recomendamos que você revise regularmente esta página para se manter informado sobre como protegemos suas informações. A data da última atualização está indicada no início desta política.
              </p>
            </section>

          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
